import { Base } from "../core/base";
import { IFieldDescription } from "../core/domain";
import { property } from "../core/property";
import { IDataProviderOwner } from "../utils/data-provider";
import { ITableCell } from "./cell";
import { FilterContext } from "./column-filter";

export interface ITableColumn extends IFieldDescription {
    filterContext: FilterContext,
    order: boolean,
    count: number,
    prev: ITableCell,
    prevValue: any,
    concatPrev: boolean,
    last: ITableCell,
    row_color: string,
    [name: string]: any;
}

export class TableColumn extends Base implements ITableColumn {

    constructor(columnDescription: IFieldDescription, private table: IDataProviderOwner) {
        super();
        Object.keys(columnDescription || {}).forEach(key => {
            if(columnDescription[key] !== undefined) {
                this[key] = columnDescription[key];
            }
        });
        if(this.title === undefined) {
            this.title = this.name;
        }
        this.filterContext = new FilterContext(this, table);
    }

    filterContext: FilterContext;
    @property() order: boolean;
    count: number;
    prev: any;
    prevValue: any;
    concatPrev: boolean;
    last: any;
    row_color: string;
    name: string;
    title: string;
    type: string = "string";
    visible: boolean = true;

    dispose() {
    }
}